// extracted by mini-css-extract-plugin
module.exports = {"row":"row__1MVCE","cell-box":"cell-box__1ugSK","cell":"cell__2w0nf","flatNumber":"flatNumber__34ktI","archivedCell":"archivedCell__Y7Ov3"};